// @noflow
import { attemptSaveSchedule, changeMode, undoAll } from '~/core/state/ui/schedule/actions';
import { getScheduleFromComponent, getScheduleMode, getScheduleType } from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import ControlPanel from './component';
import { hasSaveButton } from '../schedule-type';

const mapStateToProps = (state, { componentId }) => {
    const scheduleMode = getScheduleMode(state, { componentId });
    const areChangesMade = !!getScheduleFromComponent(state, { componentId });
    const scheduleType = getScheduleType(state, { componentId });
    const showSaveButton = hasSaveButton({ type: scheduleType });

    return {
        areChangesMade,
        scheduleMode,
        showSaveButton
    };
};

const mapDispatchToProps = {
    attemptSaveSchedule,
    changeMode,
    undoAll
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { attemptSaveSchedule, changeMode, undoAll } = dispatchProps;
    const { componentId } = ownProps;

    return {
        ...stateProps,
        ...ownProps,
        attemptSaveSchedule: () => attemptSaveSchedule({ componentId }),
        changeMode: scheduleMode => changeMode({ componentId, scheduleMode }),
        undoAll: () => undoAll({ componentId })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ControlPanel);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/index.js